import register from './register.json'

export default { register }
